/**
 * GA4 event + param taxonomy.
 *
 * Centralized so the analytics vocabulary is reviewable in one place and stays
 * snake_case (GA4 convention). Nothing here should call gtag directly -- these
 * are just the names that get handed to `track()` in lib/tracking/index.js.
 *
 * Keep names short, lowercase, snake_case. Param values must avoid PII and high
 * cardinality (no raw IDs, emails, or free text -- bucket/hash/flag instead).
 */

export const EVENTS = {
    LOGIN: 'login',
    EVENT_CREATE: 'event_create',
    EDITOR_OPEN: 'editor_open',
    EDITOR_SAVE: 'editor_save',
    PLAYER_PREF_SAVE: 'player_pref_save',
    EVENTS_VIEW_MODE: 'events_view_mode',
    EVENTS_SEARCH: 'events_search',
    ANALYTICS_REPORT: 'analytics_report',
    MANAGE_OPEN: 'manage_open',
    EXTERNAL_HELP: 'external_help',
}

/**
 * Param keys auto-stamped on every event by `track()`. Listed here only for
 * reference / consistency -- the stamping lives in index.js.
 */
export const AUTO_PARAMS = {
    ENVIRONMENT: 'environment',
    APP_VERSION: 'app_version',
}

/**
 * User-property keys set via `identify()`. GA4 user_properties are limited to
 * 25 per property and 24-char keys, so keep this list tight.
 */
export const USER_PROPS = {
    ROLE_NAME: 'role_name',
    ROLE_ID: 'role_id',
    CLIENT_ID: 'client_id',
    ENVIRONMENT: 'environment',
    APP_VERSION: 'app_version',
}
